import { waitlistByID, waitlistDelete, waitlistList } from '@/services/ventures/waitlist.service'

export default {
	namespaced: true,
	state: {
		waitlistList: { meta: { pagination: { total: 0 } } },
		waitlistItem: {},
		waitlistStatus: 'pending',
	},
	getters: {
		getWaitlistList: s => s.waitlistList,
		getWaitlistItem: s => s.waitlistItem,
		getWaitlistStatus: s => s.waitlistStatus,
	},
	mutations: {
		WAITLIST_LIST(state, value) { state.waitlistList = value },
		SET_WAITLIST_ITEM(state, value) { state.waitlistItem = value },
		WAITLIST_STATUS(state, value) { state.waitlistStatus = value },
	},
	actions: {
		async fetchWaitlistList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('WAITLIST_STATUS', 'pending')
			commit('WAITLIST_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await waitlistList(params)
				commit('WAITLIST_STATUS', 'init')
				commit('WAITLIST_LIST', data)
				return data
			} catch (error) {
				commit('WAITLIST_STATUS', 'init')
				throw error
			}
		},
		async deleteWaitlistItem({ commit }, id) {
			commit('WAITLIST_STATUS', 'pending')
			try {
				await waitlistDelete(id)
				commit('WAITLIST_STATUS', 'init')
			} catch (error) {
				commit('WAITLIST_STATUS', 'init')
				throw error
			}
		},
		async fetchWaitlistByID({ commit }, params) {
			commit('WAITLIST_STATUS', 'pending')
			try {
				const { data } = await waitlistByID(params)
				commit('WAITLIST_STATUS', 'init')
				commit('SET_WAITLIST_ITEM', data.data)
				return data
			} catch (error) {
				commit('WAITLIST_STATUS', 'init')
				return error
			}
		},
	},
}
